import React from "react";
import { useOutletContext } from "@remix-run/react";
import AdditionalContent from "~/components/additional-content/additional-content";

export default function Index() {
  const { product } = useOutletContext<any>();
  const img = product?.complementaryContent?.blobUrl;

  return <AdditionalContent img={img} />;
}
